import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ListingService, LogService } from '@app/services';


@Component({
    selector: "view-count",
    templateUrl: "./view-count.component.html",
    styleUrls: ["./view-count.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class ViewCountComponent implements OnInit {
  private readonly _componentName = 'ViewCountComponent';

  private _listingId: number;

  /**
   * The number of views to display on the listing card (views of listing within the past week)
   */
  public viewCount: number;

  public retrieving = false;

  public get listingId(): number {
    return this._listingId;
  }

  @Input()
  public set listingId(v: number) {
    this._listingId = v;

    if (v) {
      this.retrieveData(v);
    } else {
      this.viewCount = undefined;
    }
  }

  constructor(readonly listingService: ListingService, private log: LogService) {}

  ngOnInit() {}

  /**
   * Is verbose logging enabled
   */
  private get verboseLogging(): boolean {
    return this.log.verboseLogging;
  }

  public retrieveData(listingId: number) {
    this.retrieving = true;

    this.listingService.getViewCount(listingId).subscribe(
      (result) => {
        if (this.verboseLogging) {
          console.log(`${this._componentName} subscription result=`, result);
        }

        this.viewCount = result;
        this.retrieving = false;
      },
      (err) => {
        console.error(err);
        
        this.retrieving = false;
      }
    );
  }
}
